/* eslint-disable import/no-unresolved */
import React from "react";
import ShopProductPageSearch from "components/pages/user/products/ShopProductPageSearch";
import WholesaleHeaderNav from "components/elements/main/WholesaleHeaderNav";

const WholesaleShopProductPageSearch = (props) => {

    return (
        <div>
            <WholesaleHeaderNav {...props} />
            <ShopProductPageSearch {...props} wholesale={true} />
        </div>
    );
};

export default (WholesaleShopProductPageSearch);

